// extracted by mini-css-extract-plugin
module.exports = {"block":"PlayerNIL_block__gE_LW","playerDetail":"PlayerNIL_playerDetail__3leb1","deals":"PlayerNIL_deals__i6_22","nil":"PlayerNIL_nil__i4_BX","modules":"PlayerNIL_modules__Rn_IK"};